import { createElement } from 'react'
import OptimizationSummary from '~/dashboard/aws_master_optimizations/optimization_summary'
import ReactController from './react_controller'

export default class AWSMasterOptimizationsChartOnlyController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
  }

  createComponent() {
    return createElement(OptimizationSummary, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: { id: this.masterOptimizationIdValue },
    })
  }
}
